import { FragmentRESTSerializer as RESTSerializer } from 'ember-data-model-fragments/serializer';

export default class Amount extends RESTSerializer {
  normalize(modelClass, payload) {
    payload.amount = ((payload.amount ?? 0) / 100).toFixed(2);
    return super.normalize(...arguments);
  }
}
